import { Helmet } from "react-helmet-async";

const SITE = "https://strsurplus.com";

export function Seo({ title, description, path = "", jsonLd, image }) {
  const fullTitle = title ? `${title} · STR Surplus` : "STR Surplus — Liquidation & Auction-Lot Deals for Short-Term Rental Owners";
  const desc = description || "Surplus, liquidation and auction-lot goods for Airbnb & vacation rental owners, operators and managers. Below-list, condition-graded, ships UPS Ground nationwide from Fort Lauderdale, FL.";
  const url = `${SITE}${path}`;
  const img = image ? (image.startsWith("http") ? image : `${SITE}${image}`) : `${SITE}/og-image.jpg`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
